import { UserAnswerModel } from '../../../../types/userAnswer';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareDeleteUserAnswer = ({
    userAnswer,
}: {
    userAnswer: UserAnswerModel;
}) => userAnswer.prepareMarkAsDeleted();

export const logDeleteUserAnswerAction = ({
    userAnswers,
    logDBAction,
    tableName,
}: {
    userAnswers: UserAnswerModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Delete user answers',
        modelName: tableName,
        payload: userAnswers,
    });
};
